export const MIN_PHOTO_ZOOM = 1;
export const MAX_PHOTO_ZOOM = 3;
export const PHOTO_ZOOM_STEP = 0.5;
export const PHOTO_WHEEL_ZOOM_SENSITIVITY = 0.012;

export type PhotoLayout = {
  height: number;
  width: number;
};

export function clampPhotoZoom(value: number) {
  return Math.max(MIN_PHOTO_ZOOM, Math.min(MAX_PHOTO_ZOOM, value));
}

export function clampPhotoPanForLayout(
  nextPan: { x: number; y: number },
  nextZoom: number,
  layout: PhotoLayout,
) {
  if (nextZoom <= MIN_PHOTO_ZOOM) {
    return { x: 0, y: 0 };
  }

  const maxX = (layout.width * (nextZoom - MIN_PHOTO_ZOOM)) / 2;
  const maxY = (layout.height * (nextZoom - MIN_PHOTO_ZOOM)) / 2;

  return {
    x: Math.max(-maxX, Math.min(maxX, nextPan.x)),
    y: Math.max(-maxY, Math.min(maxY, nextPan.y)),
  };
}

export function nextPhotoZoomFromWheel({
  currentZoom,
  deltaY,
}: {
  currentZoom: number;
  deltaY: number;
}) {
  return clampPhotoZoom(
    currentZoom * Math.exp(-deltaY * PHOTO_WHEEL_ZOOM_SENSITIVITY),
  );
}

export function isDesktopPinchWheel({
  ctrlKey,
  metaKey,
}: {
  ctrlKey: boolean;
  metaKey: boolean;
}) {
  return ctrlKey || metaKey;
}
